/* eslint-disable no-shadow */
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import update from 'immutability-helper';
import DnDCard from './DnDCard';
import ItemTypes from './ItemTypes';
import getStatementText from '../../utils/getStatementText';
import './DnDContainer.scss';
import Card from '~types/Card';
import DnDContainerProps from '~types/components/DnDContainerProps';

const DnDContainer = function DnDContainer({
  finalResultsStatementIds,
  valueList,
  setFinalResultsStatementIds,
}: DnDContainerProps) {
  const CardsArray: Array<Card> = finalResultsStatementIds.map((result: number) => ({
    id: result,
    text: getStatementText(result, valueList),
  }));
  const [resultCards, setResultCards] = useState(CardsArray);
  const findCard = useCallback(
    id => {
      const card = resultCards.filter((c: Card) => `${c.id}` === id)[0];
      return {
        card,
        index: resultCards.indexOf(card),
      };
    },
    [resultCards]
  );
  const moveCard = useCallback(
    (id, atIndex) => {
      const { card, index } = findCard(id);
      setResultCards(
        update(resultCards, {
          $splice: [
            [index, 1],
            [atIndex, 0, card],
          ],
        })
      );
    },
    [findCard, resultCards, setResultCards]
  );
  const [, drop] = useDrop(() => ({ accept: ItemTypes.CARD }));
  useEffect(() => {
    setFinalResultsStatementIds(resultCards.map(result => result.id));
  }, [resultCards]);
  return (
    <div ref={drop} className="results-card-container">
      {resultCards.map((card: Card, i: number) => {
        return (
          <div className="result-row" key={card.id} data-testid={i}>
            <p className="result-rank">{i + 1}</p>
            <DnDCard
              key={card.id}
              id={`${card.id}`}
              text={card.text}
              moveCard={moveCard}
              findCard={findCard}
            />
          </div>
        );
      })}
    </div>
  );
};

DnDContainer.propTypes = {
  finalResultsStatementIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  valueList: PropTypes.arrayOf(PropTypes.object).isRequired,
  setFinalResultsStatementIds: PropTypes.func.isRequired,
};

export default React.memo(DnDContainer);
